import { render } from "./CurrentPackages.vue?vue&type=template&id=65fc2b40&scoped=true"
import script from "./CurrentPackages.vue?vue&type=script&lang=js"
export * from "./CurrentPackages.vue?vue&type=script&lang=js"

import "./CurrentPackages.vue?vue&type=style&index=0&id=65fc2b40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fc2b40"]])

export default __exports__